export enum WidgetType {
  BROADBAND = 'broadband',
  BUNDLE = 'bundle',
  COLLECTION = 'collection',
  COMPARISON = 'comparison',
  DEAL = 'deal',
  EAGLE = 'eagle',
  EDITORS_PICK = 'editorspick',
  INBODY = 'inbody',
  LINK = 'link',
  MAGAZINE_SUBSCRIPTIONS = 'magazinesubscriptions',
  MERCHANT_LINK = 'merchantlink',
  MERCHANT_OVERVIEW = 'merchantoverview',
  MOST_POPULAR_OFFERS = 'mostpopularoffers',
  MULTI_MODEL_REVIEW = 'multimodelreview',
  PARTNER = 'partner',
  PEACOCK = 'peacock',
  POCKET = 'pocket',
  PPC = 'ppc',
  PRICE = 'price',
  PRODUCT_BLOCK = 'productblock',
  PRODUCT_FINDER_SEARCH = 'productfindersearch',
  PRODUCT_NAME = 'productname',
  PROMOTION = 'promotion',
  REVIEW = 'review',
  REWARD_NOTIFICATIONS = 'rewardnotifications',
  REWARD_SUMMARY = 'rewardsummary',
  SCROLLABLE_TILE = 'scrollabletile',
  SEASONAL = 'seasonal',
  SIMPLE = 'simple',
  SPECS = 'specs',
  STICKY = 'sticky',
  STREAMING = 'streaming',
  TABLETOP = 'tabletop',
  TABS = 'tabs',
  TILE = 'tile',
  USER_REVIEWS = 'userreviews',
  USER_REWARDS = 'userrewards',

  ANF_BUTTON = 'anfbutton',
  ANF_COLLECTION = 'anfcollection',
  ANF_DEAL = 'anfdeal',
  ANF_FEATURED_PRODUCT_BLOCK = 'anffeaturedproductblock',
  ANF_MULTIMODEL = 'anfmultimodel',
  ANF_REVIEW = 'anfreview',
  ANF_TABLETOP = 'anftabletop',

  HAWKLINK = 'hawklink',
}
